import React from "react";

const CityIcon = (props: any) => {
  return (
    <div>
      <svg
        fill="#000000"
        height="24"
        width="24"
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
      >
        <g>
          <g>
            <path
              d="M469.289,48.943H361.93c-5.632,0-10.199,4.566-10.199,10.199v187.747h-69.976v-83.336V10.199
			C281.755,4.566,277.188,0,271.556,0h-61.352c-5.632,0-10.199,4.566-10.199,10.199v143.154h-22.538V96.892
			c0-5.633-4.567-10.199-10.199-10.199c-5.632,0-10.199,4.566-10.199,10.199v56.461h-11.034c-5.632,0-10.199,4.566-10.199,10.199
			v49.619H83.634v-37.745c0-5.633-4.567-10.199-10.199-10.199s-10.199,4.566-10.199,10.199v37.746H42.711
			c-5.632,0-10.199,4.566-10.199,10.199v278.429c0,5.633,4.567,10.199,10.199,10.199h426.578c5.632,0,10.199-4.566,10.199-10.199
			V59.142C479.488,53.509,474.921,48.943,469.289,48.943z M135.835,491.602H52.91V233.571h82.925V491.602z M261.357,491.602H156.233
			v-317.85h105.123V491.602z M261.357,153.353h-40.954V20.398h40.954V153.353z M351.723,491.602h-69.968V267.286h69.968V491.602z
			 M459.09,491.602h-86.96V69.341h86.96V491.602z"
              fill={props?.color ?? "black"}
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M186.276,199.033c-5.632,0-10.199,4.566-10.199,10.199v13.542c0,5.633,4.566,10.199,10.199,10.199
			c5.632,0,10.199-4.566,10.199-10.199v-13.542C196.475,203.6,191.908,199.033,186.276,199.033z"
              fill={props?.color ?? "black"}
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M229.781,199.033c-5.632,0-10.199,4.566-10.199,10.199v13.542c0,5.633,4.567,10.199,10.199,10.199
			c5.632,0,10.199-4.566,10.199-10.199v-13.542C239.98,203.6,235.413,199.033,229.781,199.033z"
              fill={props?.color ?? "black"}
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M240.656,105.499c-5.632,0-10.199,4.566-10.199,10.199v13.542c0,5.633,4.567,10.199,10.199,10.199
			s10.199-4.566,10.199-10.199v-13.542C250.856,110.065,246.289,105.499,240.656,105.499z"
              fill={props?.color ?? "black"}
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M240.656,52.206c-5.632,0-10.199,4.566-10.199,10.199v13.542c0,5.633,4.567,10.199,10.199,10.199
			s10.199-4.566,10.199-10.199V62.405C250.856,56.772,246.289,52.206,240.656,52.206z"
              fill={props?.color ?? "black"}
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M186.276,258.412c-5.632,0-10.199,4.566-10.199,10.199v13.542c0,5.633,4.566,10.199,10.199,10.199
			c5.632,0,10.199-4.566,10.199-10.199v-13.542C196.475,262.978,191.908,258.412,186.276,258.412z"
              fill={props?.color ?? "black"}
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M229.781,258.412c-5.632,0-10.199,4.566-10.199,10.199v13.542c0,5.633,4.567,10.199,10.199,10.199
			c5.632,0,10.199-4.566,10.199-10.199v-13.542C239.98,262.978,235.413,258.412,229.781,258.412z"
              fill={props?.color ?? "black"}
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M186.276,313.622c-5.632,0-10.199,4.566-10.199,10.199v13.543c0,5.633,4.566,10.199,10.199,10.199
			c5.632,0,10.199-4.566,10.199-10.199v-13.542C196.475,318.189,191.908,313.622,186.276,313.622z"
              fill={props?.color ?? "black"}
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M229.781,313.622c-5.632,0-10.199,4.566-10.199,10.199v13.543c0,5.633,4.567,10.199,10.199,10.199
			c5.632,0,10.199-4.566,10.199-10.199v-13.542C239.98,318.189,235.413,313.622,229.781,313.622z"
              fill={props?.color ?? "black"}
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M186.276,373.001c-5.632,0-10.199,4.566-10.199,10.199v13.543c0,5.633,4.566,10.199,10.199,10.199
			c5.632,0,10.199-4.566,10.199-10.199V383.2C196.475,377.567,191.908,373.001,186.276,373.001z"
              fill={props?.color ?? "black"}
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M229.781,373.001c-5.632,0-10.199,4.566-10.199,10.199v13.543c0,5.633,4.567,10.199,10.199,10.199
			c5.632,0,10.199-4.566,10.199-10.199V383.2C239.98,377.567,235.413,373.001,229.781,373.001z"
              fill={props?.color ?? "black"}
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M186.276,432.379c-5.632,0-10.199,4.566-10.199,10.199v13.543c0,5.633,4.566,10.199,10.199,10.199
			c5.632,0,10.199-4.566,10.199-10.199v-13.542C196.475,436.945,191.908,432.379,186.276,432.379z"
              fill={props?.color ?? "black"}
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M229.781,432.379c-5.632,0-10.199,4.566-10.199,10.199v13.543c0,5.633,4.567,10.199,10.199,10.199
			c5.632,0,10.199-4.566,10.199-10.199v-13.542C239.98,436.945,235.413,432.379,229.781,432.379z"
              fill={props?.color ?? "black"}
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M398.361,199.033c-5.632,0-10.199,4.566-10.199,10.199v13.542c0,5.633,4.567,10.199,10.199,10.199
			c5.632,0,10.199-4.566,10.199-10.199v-13.542C408.56,203.6,403.993,199.033,398.361,199.033z"
              fill={props?.color ?? "black"}
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M436.427,199.033c-5.632,0-10.199,4.566-10.199,10.199v13.542c0,5.633,4.567,10.199,10.199,10.199
			s10.199-4.566,10.199-10.199v-13.542C446.626,203.6,442.059,199.033,436.427,199.033z"
              fill={props?.color ?? "black"}
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M398.361,258.412c-5.632,0-10.199,4.566-10.199,10.199v13.542c0,5.633,4.567,10.199,10.199,10.199
			c5.632,0,10.199-4.566,10.199-10.199v-13.542C408.56,262.978,403.993,258.412,398.361,258.412z"
              fill={props?.color ?? "black"}
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M436.427,258.412c-5.632,0-10.199,4.566-10.199,10.199v13.542c0,5.633,4.567,10.199,10.199,10.199
			s10.199-4.566,10.199-10.199v-13.542C446.626,262.978,442.059,258.412,436.427,258.412z"
              fill={props?.color ?? "black"}
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M398.361,313.622c-5.632,0-10.199,4.566-10.199,10.199v13.543c0,5.633,4.567,10.199,10.199,10.199
			c5.632,0,10.199-4.566,10.199-10.199v-13.542C408.56,318.189,403.993,313.622,398.361,313.622z"
              fill={props?.color ?? "black"}
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M436.427,313.622c-5.632,0-10.199,4.566-10.199,10.199v13.543c0,5.633,4.567,10.199,10.199,10.199
			s10.199-4.566,10.199-10.199v-13.542C446.626,318.189,442.059,313.622,436.427,313.622z"
              fill={props?.color ?? "black"}
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M398.361,85.688c-5.632,0-10.199,4.566-10.199,10.199v13.543c0,5.633,4.567,10.199,10.199,10.199
			c5.632,0,10.199-4.566,10.199-10.199V95.887C408.56,90.254,403.993,85.688,398.361,85.688z"
              fill={props?.color ?? "black"}
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M436.427,85.688c-5.632,0-10.199,4.566-10.199,10.199v13.543c0,5.633,4.567,10.199,10.199,10.199
			s10.199-4.566,10.199-10.199V95.887C446.626,90.254,442.059,85.688,436.427,85.688z"
              fill={props?.color ?? "black"}
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M398.361,140.899c-5.632,0-10.199,4.566-10.199,10.199v13.542c0,5.633,4.567,10.199,10.199,10.199
			c5.632,0,10.199-4.566,10.199-10.199v-13.542C408.56,145.465,403.993,140.899,398.361,140.899z"
              fill={props?.color ?? "black"}
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M436.427,140.899c-5.632,0-10.199,4.566-10.199,10.199v13.542c0,5.633,4.567,10.199,10.199,10.199
			s10.199-4.566,10.199-10.199v-13.542C446.626,145.465,442.059,140.899,436.427,140.899z"
              fill={props?.color ?? "black"}
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M398.361,373.001c-5.632,0-10.199,4.566-10.199,10.199v13.543c0,5.633,4.567,10.199,10.199,10.199
			c5.632,0,10.199-4.566,10.199-10.199V383.2C408.56,377.567,403.993,373.001,398.361,373.001z"
              fill={props?.color ?? "black"}
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M436.427,373.001c-5.632,0-10.199,4.566-10.199,10.199v13.543c0,5.633,4.567,10.199,10.199,10.199
			s10.199-4.566,10.199-10.199V383.2C446.626,377.567,442.059,373.001,436.427,373.001z"
              fill={props?.color ?? "black"}
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M398.361,432.379c-5.632,0-10.199,4.566-10.199,10.199v13.543c0,5.633,4.567,10.199,10.199,10.199
			c5.632,0,10.199-4.566,10.199-10.199v-13.542C408.56,436.945,403.993,432.379,398.361,432.379z"
              fill={props?.color ?? "black"}
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M436.427,432.379c-5.632,0-10.199,4.566-10.199,10.199v13.543c0,5.633,4.567,10.199,10.199,10.199
			s10.199-4.566,10.199-10.199v-13.542C446.626,436.945,442.059,432.379,436.427,432.379z"
              fill={props?.color ?? "black"}
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M113.405,253.414H76.428c-5.632,0-10.199,4.566-10.199,10.199s4.567,10.199,10.199,10.199h36.978
			c5.632,0,10.199-4.566,10.199-10.199S119.038,253.414,113.405,253.414z"
              fill={props?.color ?? "black"}
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M113.405,292.928H76.428c-5.632,0-10.199,4.566-10.199,10.199c0,5.633,4.567,10.199,10.199,10.199h36.978
			c5.632,0,10.199-4.566,10.199-10.199C123.605,297.494,119.038,292.928,113.405,292.928z"
              fill={props?.color ?? "black"}
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M113.405,333.718H76.428c-5.632,0-10.199,4.566-10.199,10.199c0,5.633,4.567,10.199,10.199,10.199h36.978
			c5.632,0,10.199-4.566,10.199-10.199C123.605,338.284,119.038,333.718,113.405,333.718z"
              fill={props?.color ?? "black"}
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M113.405,373.232H76.428c-5.632,0-10.199,4.566-10.199,10.199c0,5.633,4.567,10.199,10.199,10.199h36.978
			c5.632,0,10.199-4.566,10.199-10.199C123.605,377.798,119.038,373.232,113.405,373.232z"
              fill={props?.color ?? "black"}
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M113.405,414.021H76.428c-5.632,0-10.199,4.566-10.199,10.199c0,5.633,4.567,10.199,10.199,10.199h36.978
			c5.632,0,10.199-4.566,10.199-10.199C123.605,418.588,119.038,414.021,113.405,414.021z"
              fill={props?.color ?? "black"}
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M113.405,453.535H76.428c-5.632,0-10.199,4.566-10.199,10.199c0,5.633,4.567,10.199,10.199,10.199h36.978
			c5.632,0,10.199-4.566,10.199-10.199C123.605,458.101,119.038,453.535,113.405,453.535z"
              fill={props?.color ?? "black"}
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M328.753,281.692H302.65c-5.632,0-10.199,4.566-10.199,10.199c0,5.633,4.567,10.199,10.199,10.199h26.103
			c5.632,0,10.199-4.566,10.199-10.199C338.952,286.258,334.385,281.692,328.753,281.692z"
              fill={props?.color ?? "black"}
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M328.753,329.547H302.65c-5.632,0-10.199,4.566-10.199,10.199c0,5.633,4.567,10.199,10.199,10.199h26.103
			c5.632,0,10.199-4.566,10.199-10.199C338.952,334.114,334.385,329.547,328.753,329.547z"
              fill={props?.color ?? "black"}
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M328.753,378.489H302.65c-5.632,0-10.199,4.566-10.199,10.199c0,5.633,4.567,10.199,10.199,10.199h26.103
			c5.632,0,10.199-4.566,10.199-10.199C338.952,383.056,334.385,378.489,328.753,378.489z"
              fill={props?.color ?? "black"}
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M328.753,428.52H302.65c-5.632,0-10.199,4.566-10.199,10.199c0,5.633,4.567,10.199,10.199,10.199h26.103
			c5.632,0,10.199-4.566,10.199-10.199C338.952,433.086,334.385,428.52,328.753,428.52z"
              fill={props?.color ?? "black"}
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M167.267,43.857c-5.632,0-10.199,4.566-10.199,10.199v12.239c0,5.633,4.567,10.199,10.199,10.199
			c5.632,0,10.199-4.566,10.199-10.199V54.056C177.466,48.423,172.899,43.857,167.267,43.857z"
              fill={props?.color ?? "black"}
            />
          </g>
        </g>
      </svg>
    </div>
  );
};

export default CityIcon;
